import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';

import AdviceSection from '../common/AdviceSection';
import SubMenuTabs from '../common/subMenuTabs/SubMenuTabs';
import DatasetSelectTrend from '../common/select-filters/DatasetSelectTrend';
import DigitalisationRisksChart from '../common/charts/DigitalisationRisksChart';
import Methodology from '../common/Methodology';
import Related from '../common/Related';

import { digitalisationRisksTab } from '../../model/subMenuTabs';

const DigitalisationRisks = props => {

	let selected = '', selectedSecondLevel = '', secondLevel = '';

	for (let i = 0; i < digitalisationRisksTab.length; i++)
	{
		if (digitalisationRisksTab[i].url == props.tab)
		{
			selected = digitalisationRisksTab[i];
		}
	}

	// If the current tab has sub-tabs, set the selected one
	if (selected.subTabs != undefined)
	{
		secondLevel = selected.subTabs;
		for (let i = 0; i < selected.subTabs.length; i++)
		{
			if (selected.subTabs[i].url == props.indicator)
			{
				selectedSecondLevel = selected.subTabs[i];
			}
		}
	}

	const currentPath = '/working-conditions-preventions/digitalisation-risks/';
	const selectedSurvey = '';

	const [secondLevelTabs, setSecondLevelTabs] = useState(secondLevel);
	const [selectedTab, setSelectedTab] = useState(selected);
	const [secondLevelSelectedTab, setSecondLevelSelectedTab] = useState(selectedSecondLevel);
	const [chartDimension, setChartDimension] = useState(window.innerWidth > 768 ? 'column' : 'bar');
	const [selectedDataset1, setSelectedDataset1] = useState(null);
	const [selectedDataset2, setSelectedDataset2] = useState(null);

	useEffect(() => {
		// Update the title of the page
        document.title = "Digitalisation risks " + " - " + props.literals.L22020 + " - " + props.literals.L363;
        window.addEventListener('resize', updateDimension);

		if(selectedTab == 'pace-work'){
			setSelectedTab('pace-work');
		}
	}, [])

    const callbackSelectedIndicator = (callback) => {
		// This function will be called when changing the indicator for Exposure to Dangerous Substances
		for (let i = 0; i < secondLevelTabs.length; i++)
		{
			if (callback == secondLevelTabs[i].url)
			{
				setSecondLevelSelectedTab(secondLevelTabs[i]);
			}
		}
	}

    const callbackSelectedTab = (callback) => {
        for (let i = 0; i < digitalisationRisksTab.length; i++)
        {
            if (callback == digitalisationRisksTab.url)
            {
				setSelectedTab(digitalisationRisksTab[i]);
				setSecondLevelTabs(digitalisationRisksTab[i].subTabs);
				setSecondLevelSelectedTab(digitalisationRisksTab[i].subTabs[0]);
            }
        }	
	}

    const updateDimension = () => {
		if(window.innerWidth > 768){
			setChartDimension('column');
		}else{
			setChartDimension('bar');
		}
	}

    const handleDatasetChange1 = (dataset) => {
		setSelectedDataset1(dataset);
	}

    return (
		<div className="digitalisation-risks">
			<AdviceSection literals={ props.literals } section={["working-conditions-preventions","digitalisation-risks"]} 
				methodologyData={{section: 'working-conditions-preventions', subsection: 'Working conditions - Digitalisation risks', indicator: 65}} />

			{/*First submenu*/}
			<div>
				<SubMenuTabs 
					literals={ props.literals }
					selectedTab={ selectedTab.url }
					callbackSelectedTab={ callbackSelectedTab }
					locationPath={ currentPath }
					subMenuTabs={ digitalisationRisksTab }
				/>
			</div>

			<div className="line background-main-light" />

			{/*Second submenu*/}
			<div>
				<SubMenuTabs 
					literals={ props.literals }
					selectedTab={ secondLevelSelectedTab.url }
					selectedSurvey={ selectedSurvey }  
					callbackSelectedTab={ callbackSelectedIndicator }
					locationPath={`${currentPath}${selectedTab.url}/`}
					subMenuTabs={ secondLevelTabs }
				/>
			</div>

			<div className="line background-main-light" />

			<DatasetSelectTrend
				literals={ props.literals }
				chartType={ secondLevelSelectedTab.chartType }
				handleDatasetChange1={ handleDatasetChange1 }
				showSourceSelect={ false }
				showAnswerSelect={ false }
				selectedIndicator={ secondLevelSelectedTab.chartType[0].chartIndicator }
				yearOnly={ false }
			/>

			<div className="line background-main-light" />

			<div className="container section--page card--grid xxs-w1 xs-w1 w1 center-text" >
				<div className="card--block--chart" >
					<div className="chart--block with-filter" >
						<div className="card--block--chart--wrapper" >
							<div className="chart--wrapper" >
								<DigitalisationRisksChart 
									literals={ props.literals }
									percentage={ true }
									type={ chartDimension }
									colors={ ['#f6a400','#cbe2e3'] }
									chartType={ secondLevelSelectedTab.chartType }
									decimalNumbers="0"
									dataset={ selectedDataset1 }
								/>
							</div>
						</div>
					</div>
				</div>
				<div className="chart-legend">
					{ReactHtmlParser(props.literals[`L${secondLevelSelectedTab.chartType[0].legend}`])}
				</div>
			</div>

			<Methodology literals={ props.literals } section={'Working conditions - Digitalisation risks'} indicator={ secondLevelSelectedTab.chartType[0].chartIndicator } />

			<Related literals={ props.literals } section={["working-conditions-preventions", "digitalisation-risks"]} />
		</div>
	)
}

export default DigitalisationRisks;
DigitalisationRisks.displayName = 'DigitalisationRisks';